export default "__VITE_ASSET__CNDdCTwo__"